import { graphql } from 'gatsby';
import { exists, getKey, isValidArray } from '../../../helpers';
import translations from '../../../constants/translations';


/**
 * Questions extractor helper function
 * @param {Array} questions array of questions
 * @param {string} locale of the questions
 * @returns {Array} with questions object
 */
function getQuestions(questions, locale) {
  if (isValidArray(questions)) {
    return questions.map(q => ({
      key: getKey(q, 'key'),
      question: getKey(q, `question_${locale}`),
      answer: getKey(q, `answer_${locale}`)
    }));
  }

  return null;
}

/**
 * Faq widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the widget
 * @returns {Object} widget definition
 */
export const faq = function (props, locale) {
  const categoryQuestions = getKey(props, 'categoryquestions');
  const searchPlaceHolder = getKey(props, `searchPlaceHolder_${locale}`);
  const seeMoreQuestions = getKey(props, `seeMoreQuestions_${locale}`);
  const seeMoreQuestionsLink = getKey(props, 'seeMoreQuestionsLink');

  const obj = {
    type: 'faq',
    translations: translations[locale],
    key: getKey(props, 'key'),
    searchPlaceHolder: exists(searchPlaceHolder) ? searchPlaceHolder : null,
    hasSearch: getKey(props, 'hasSearch'),
    seeMoreQuestions: exists(seeMoreQuestions) ? seeMoreQuestions : null,
    seeMoreQuestionsLink: exists(seeMoreQuestionsLink) ? `${locale}${seeMoreQuestionsLink}` : null,
    categoryQuestions: isValidArray(categoryQuestions) && categoryQuestions.map(cat => ({
      key: getKey(cat, 'key'),
      category: getKey(cat, `category_${locale}`),
      icon: exists(getKey(cat, 'icon.url')) ? getKey(cat, 'icon.url') : null,
      questions: getQuestions(getKey(cat, 'questions'), locale)
    })),
  };

  return obj;
}

export default function stepProvider(props, locale) {
  const key = getKey(props, 'key');

  return {
    locale,
    faqId: key
  };
}

export const query = graphql`
  fragment Faqs on StrapiWidgetrels {
    faq {
      key: id
      searchPlaceHolder_en
      searchPlaceHolder_es
      hasSearch
      seeMoreQuestions_en
      seeMoreQuestions_es
      seeMoreQuestionsLink
      categoryquestions {
        key: id
        category_en
        category_es
        questions {
          key: id
          question_en
          question_es
          answer_en
          answer_es
        }
        icon {
          publicURL
        }
      }
      widgetPosition
    }
  }
`;
